import React from "react";
import { at } from "lodash";
import { useField } from "formik";
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from "@material-ui/core";

export default function MCheckBoxManual(props) {
    const { label, labelPlacement, onChange, ...rest } = props;
    const [field, meta] = useField(props);
    // const { setValue } = helper;

    function _renderHelperText() {
        const [touched, error] = at(meta, "touched", "error");
        if (touched && error) {
            return <FormHelperText>{error}</FormHelperText>;
        }
    }

    // function _onChange(e) {
    //   setValue(e.target.checked);
    // }

    return (
        <FormControl {...rest}>
            <FormControlLabel
                //value={field.checked}
                //checked={field.value
                control={
                    <Checkbox
                        {...field}
                        value={field.checked}
                        checked={field.value}
                        onChange={onChange}
                        color="primary"
                    />
                }
                label={label}
                labelPlacement={labelPlacement}
            />
            {_renderHelperText()}
        </FormControl>
    );
}

MCheckBoxManual.defaultProps = {
    labelPlacement: "end"
};
